<template>
  <div class="DecorationHomepage-container">
    <el-row class="tcf-row">
      <el-col :span="24" class="card">
        <div class="card-body">
          <div class="card-title">
            项目跟进
          </div>
          <div class="card-content" v-loading="loading">
            <el-row>
              <el-col :span="5">
                <el-row>
                  <el-col :span="16" class="client-info-row">
                    <span class="client-name">{{info.name}}</span>
                  </el-col>
                  <el-col :span="8" style="text-align: right">
                    <el-button type="text" size="small" icon="el-icon-edit" @click="editInfo">编辑信息</el-button>
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <el-tag type="danger" size="mini" v-if="info.mark===0">未开始</el-tag>
                    <el-tag type="warning" size="mini" v-if="info.mark===1">进行中</el-tag>
                    <el-tag size="mini" v-if="info.mark===9">已完成</el-tag>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">识别码：</span> <span style="font-weight: 500;color:#F56C6C">{{info.ident}}</span>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">客户名称：</span> {{info.custname}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">联系电话：</span> {{info.tel}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">所在地区：</span> {{info.province}} {{info.city}} {{info.county}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <span style="color:#99a9bf">详细地址：</span> {{info.address}}
                  </el-col>
                  <el-col :span="24" class="client-info-row" v-if="info.mark!==9">
                    <span style="color:#99a9bf">当前阶段：</span> <span style="font-weight: 500;color:#409EFF">{{info.stage}}</span>
                  </el-col>
                  <el-col :span="24" class="client-info-row" v-if="info.mark!==9">
                    <span style="color:#99a9bf">下个阶段：</span> <span style="font-weight: 500;color:#67C23A">{{info.nextstage!==null&&info.nextstage!==''&&info.nextstage!==undefined?info.nextstage:'完成'}}</span>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">计划开工：</span> {{info.starttime}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <span style="color:#99a9bf">计划完工：</span> {{info.endtime}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">设计师：</span> {{info.designer_name}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">客服：</span> {{info.customer_name}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">销售内勤：</span> {{info.sales_name}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <span style="color:#99a9bf">项目经理：</span> {{info.foreman_name}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    已有<span style="font-size: 14px;font-weight: 500;color:#409EFF;margin:0 6px">{{followlst.length}}</span>次跟进
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="19">
                <el-timeline>
                  <el-timeline-item timestamp="" placement="top">
                    <el-button size="small" type="primary" @click="addRecord">添加跟进</el-button>
                  </el-timeline-item>
                  <el-timeline-item v-for="ritem in followlst" :timestamp="ritem.time" placement="top">
                    <el-card>
                      <el-button v-if="ritem.userid===user.userid" @click="editRecord(ritem)" class="follow-editbtn" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                      <h4 class="follow-txt">
                        <i class="el-icon-time" style="color:#E6A23C" v-if="ritem.isfinish===0&&ritem.stage!=='完成'"></i>
                        <i class="el-icon-success" style="color:#67C23A" v-if="ritem.isfinish===1&&ritem.stage!=='完成'"></i>
                        <span v-if="ritem.stage!=='完成'">{{ritem.stage}}</span>
                        <span :style="ritem.stage!=='完成'?'margin:0 20px':''">
                          <i class="el-icon-user-solid" style="color:#99a9bf"></i>
                          {{ritem.username}}
                        </span>
                        <el-tag v-if="ritem.overdue===2" size="mini" :disable-transitions="true" type="success" style="font-weight: 400">提早完成</el-tag>
                        <el-tag v-if="ritem.overdue===1" size="mini" :disable-transitions="true" type="danger" style="font-weight: 400">逾期 {{ritem.overdueday}} 天</el-tag>
                      </h4>
                      <p class="follow-content"> {{ritem.centent}}</p>
                      <div>
                        <el-image v-for="img in ritem.imgList"
                                  style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                                  :src="img.imgurl"
                                  :preview-src-list="ritem.imgurls">
                        </el-image>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="addTitle"
      :visible.sync="addVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="addForm" :model="addForm" :rules="rulesAdd"  label-position="right" label-width="75px" size="small">
        <el-form-item label="当前阶段" prop="stage">
          <el-input v-model="addForm.stage" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="阶段进度" prop="isfinish" v-if="addForm.stage!=='完成'">
          <el-radio :disabled="editDisabled" v-model="addForm.isfinish" :label="0">进行中</el-radio>
          <el-radio :disabled="editDisabled" v-model="addForm.isfinish" :label="1">已完成</el-radio>
        </el-form-item>
        <el-form-item label="阶段图片" prop="imgids">
          <MultiImg :limit="9" :size="'sm'"  :old="editimgList" :key="imgLoad" ref="img" v-model="addForm.imgids" />
        </el-form-item>
        <el-form-item label="跟进内容" prop="centent">
          <el-input type="textarea" v-model="addForm.centent" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="addLoading" @click="submitForm('addForm')">立即提交</el-button>
          <el-button @click="addVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="编辑信息"
      :visible.sync="htVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="htForm" :model="htForm" :rules="rulesHt"  label-position="right" label-width="75px" size="small">
        <el-form-item label="房屋标识" prop="name">
          <el-input v-model="htForm.name" maxlength="200" />
        </el-form-item>
        <el-form-item label="客户名称" prop="custname">
          <el-input v-model="htForm.custname" maxlength="10" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="htForm.tel" maxlength="11" minlength="11" />
        </el-form-item>
        <el-form-item label="房屋地址" prop="address">
          <el-input placeholder="请输入详细地址" v-model="htForm.address" maxlength="200" show-word-limit class="input-with-select">
            <el-cascader
              v-model="htForm.city"
              placeholder="请选择省/市/县区"
              slot="prepend"
              clearable
              style="width:200px"
              :options="cityoptions"
              filterable/>
            <el-button slot="append" @click="flushMap" icon="el-icon-place"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="房屋定位" prop="gps">
          <div style="color: #99a9bf;font-size: 12px"><i class="el-icon-info"></i> 当前GPS经纬度：<b v-if="htForm.lng!==null&&htForm.lng!==undefined&&htForm.lng!==''&&htForm.lat!==null&&htForm.lat!==undefined&&htForm.lat!==''">{{ htForm.lng }},{{ htForm.lat }}</b><b v-if="htForm.lng===null||htForm.lng===undefined||htForm.lng===''||htForm.lat===null||htForm.lat===undefined||htForm.lat===''">无</b></div>
          <div ref="map" class="txmap" v-show="htForm.lng!==null&&htForm.lng!==undefined&&htForm.lng!==''&&htForm.lat!==null&&htForm.lat!==undefined&&htForm.lat!==''" style="width: 100%;height: 300px"></div>
        </el-form-item>
        <el-form-item label="房屋风格" prop="style">
          <el-select v-model="htForm.style">
            <el-option
              v-for="item in styleList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area">
          <el-select v-model="htForm.area">
            <el-option
              v-for="item in areaList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋户型" prop="house">
          <el-select v-model="htForm.house">
            <el-option
              v-for="item in bedRoomList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设计师" prop="designer">
          <el-select v-model="htForm.designer" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服" prop="customer">
          <el-select v-model="htForm.customer" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售内勤" prop="sales">
          <el-select v-model="htForm.sales" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目经理" prop="foreman">
          <el-select v-model="htForm.foreman" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="htloading" @click="submitHt()">立即提交</el-button>
          <el-button @click="htVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelDecorationDetail, addOrEditDecorationFollow, editDelDecorationInfo } from '@/api/dealer'
import MultiImg from '@/components/upload/MultiImg'
import { getCity } from '@/utils/city'
import { validatePhoneNumber } from '@/utils/validate'
import { getDealerGroupReport } from '@/api/group/group'
import { getWxStyleList } from '@/api/pub'
import { getAreaList, getBedRoomList } from '@/api/community'
import { getDealerDetail } from '@/api/work'

export default {
  name: 'DecorationHomepage',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    const validateAddress = (rule, value, callback) => {
      if (this.htForm.city.length <= 0) {
        callback(new Error('请选择省/市/县区'))
      } else {
        if (this.htForm.address !== null && this.htForm.address !== undefined && this.htForm.address.trim() !== '') {
          callback()
        } else {
          callback(new Error('请输入详细地址'))
        }
      }
    }
    const validateGPS = (rule, value, callback) => {
      if (this.htForm.lng !== null && this.htForm.lng !== undefined && this.htForm.lng !== '' && this.htForm.lat !== null && this.htForm.lat !== undefined && this.htForm.lat !== '') {
        callback()
      } else {
        callback(new Error('请选择房屋定位'))
      }
    }
    return {
      bid: 0,
      did: undefined,
      tempRoute: {},
      loading: false,
      info: {},
      styleList: [],
      areaList: [],
      bedRoomList: [],
      stagelst: [],
      followlst: [],
      addVisible: false,
      addTitle: '添加跟进记录',
      addLoading: false,
      imgLoad: '',
      editDisabled: false,
      editimgList: [],
      addForm: {
        dfid: 0,
        stage: '',
        isfinish: 0,
        imgids: [],
        centent: ''
      },
      rulesAdd: {
        assign_name: [{ required: true, message: '当前阶段', trigger: 'blur' }],
        isfinish: [{ required: true, message: '请选择阶段进度', trigger: 'change' }],
        remark: [{ required: true, message: '请输入跟进内容', trigger: 'blur' }]
      },
      htVisible: false,
      cityoptions: getCity(),
      htForm: {
        name: '',
        custname: '',
        tel: '',
        city: [],
        address: '',
        lng: '',
        lat: '',
        style: '',
        area: '',
        house: '',
        designer: null,
        customer: null,
        sales: null,
        foreman: null
      },
      rulesHt: {
        name: [{ required: true, message: '请输入房屋标识', trigger: 'blur' }],
        custname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        city: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
        address: [{ required: true, trigger: 'blur', validator: validateAddress }],
        designer: [{ required: true, message: '请选择设计师', trigger: 'change' }],
        customer: [{ required: true, message: '请选择客服', trigger: 'change' }],
        foreman: [{ required: true, message: '请选择项目经理', trigger: 'change' }],
        gps: [{ required: true, trigger: 'change', validator: validateGPS }],
        style: [{ required: true, message: '请选择房屋风格', trigger: 'change' }],
        area: [{ required: true, message: '请选择房屋面积', trigger: 'change' }],
        house: [{ required: true, message: '请选择房屋户型', trigger: 'change' }],
      },
      deluserlst: [],
      htloading: false
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.did = this.$route.params && this.$route.params.id
    this.getData()
    this.getDealerGroup()
    this.getBrandList()
    this.getAreaList()
    this.getBedRoomList()
  },
  methods: {
    getAreaList() {
      getAreaList().then(response => {
        this.areaList = response.data
      })
    },
    getBedRoomList() {
      getBedRoomList().then(response => {
        this.bedRoomList = response.data
      })
    },
    initMap() {
      var that = this
      this.$nextTick(() => {
        const txmap = this.$refs.map
        if (txmap !== null) {
          var center = new qq.maps.LatLng(that.htForm.lat, that.htForm.lng)
          var map = new qq.maps.Map(txmap, {
            center: center,
            zoom: 20
          })
          var anchor = new qq.maps.Point(35, 70),
            size = new qq.maps.Size(70, 70),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage('https://www.mulu.life/efile/upload/temp/map_marker.png', size, origin, anchor)
          var marker = new qq.maps.Marker({
            position: center,
            icon: icon,
            map: map,
            Draggable: true
          })
          qq.maps.event.addListener(marker, 'dragend', function() {
            var weizhi = marker.getPosition()
            that.htForm.lng = weizhi.lng
            that.htForm.lat = weizhi.lat
          })
          qq.maps.event.addListener(map, 'click', function(event) {
            that.htForm.lng = event.latLng.getLng()
            that.htForm.lat = event.latLng.getLat()
            var newcenter = new qq.maps.LatLng(that.htForm.lat, that.htForm.lng)
            marker.setPosition(newcenter)
          })
        }
      })
    },
    flushMap() {
      if (this.htForm.city.length > 0 && this.htForm.address !== null && this.htForm.address !== undefined && this.htForm.address.trim() !== '') {
        const geocoder = new qq.maps.Geocoder()
        const address = `${this.htForm.city[0]}` + `${this.htForm.city[1]}` + `${this.htForm.city[2]}` + `${this.htForm.address}`
        const that = this
        geocoder.getLocation(address)
        geocoder.setComplete(function(result) {
          that.htForm.lng = result.detail.location.lng
          that.htForm.lat = result.detail.location.lat
          that.initMap()
        })
      } else {
        this.$message.error('请完善房屋地址再进行定位')
      }
    },
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
          this.getStyleList()
        }
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        let _styleList = []
        for (const s of response.data) {
          if (s.bid === this.bid) {
            _styleList.push(s)
          }
        }
        this.styleList = _styleList
      })
    },
    getDealerGroup() {
      getDealerGroupReport({ delid: this.user.delid }).then(response => {
        this.deluserlst = response.data.userlst
      })
    },
    editInfo() {
      let city = []
      if (this.info.province !== null && this.info.province !== '' && this.info.province !== undefined) {
        city.push(this.info.province)
      }
      if (this.info.city !== null && this.info.city !== '' && this.info.city !== undefined) {
        city.push(this.info.city)
      }
      if (this.info.county !== null && this.info.county !== '' && this.info.county !== undefined) {
        city.push(this.info.county)
      }
      this.htForm = {
        name: this.info.name,
        custname: this.info.custname,
        tel: this.info.tel,
        city: city,
        address: this.info.address,
        lng: this.info.lng,
        lat: this.info.lat,
        style: this.info.style,
        area: this.info.area,
        house: this.info.house,
        designer: this.info.designer !== 0 ? this.info.designer : null,
        customer: this.info.customer !== 0 ? this.info.customer : null,
        sales: this.info.sales !== 0 ? this.info.sales : null,
        foreman: this.info.foreman !== 0 ? this.info.foreman : null
      }
      this.htVisible = true
      this.initMap()
    },
    submitHt() {
      this.$refs['htForm'].validate((valid) => {
        if (valid) {
          if (!this.htloading) {
            this.htloading = true
            const data = {
              did: this.info.did,
              name: this.htForm.name,
              custname: this.htForm.custname,
              tel: this.htForm.tel,
              province: this.htForm.city[0],
              city: this.htForm.city[1],
              county: this.htForm.city[2],
              address: this.htForm.address,
              lng: this.htForm.lng,
              lat: this.htForm.lat,
              style: this.htForm.style,
              area: this.htForm.area,
              house: this.htForm.house,
              designer: this.htForm.designer,
              customer: this.htForm.customer,
              sales: this.htForm.sales,
              foreman: this.htForm.foreman
            }
            editDelDecorationInfo(data).then(response => {
              this.$message({
                message: '信息编辑成功',
                type: 'success'
              })
              this.htVisible = false
              this.htloading = false
              this.getData()
            }).catch(() => {
              this.htloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    getData() {
      if (this.did !== null && this.did !== undefined && this.did !== '') {
        this.loading = true
        getDelDecorationDetail({ did: this.did }).then(response => {
          this.info = response.data.decoration
          this.stagelst = response.data.stagelst
          this.followlst = response.data.followlst
          const pageTitle = `项目跟进 - ${this.info.name}`
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, { title: pageTitle })
          this.$store.dispatch('tagsView/updateVisitedView', route)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.$message.error('获取项目信息失败')
      }
    },
    addRecord() {
      this.addForm.stage = this.info.stage
      if (this.addForm.stage === '完成') {
        this.editDisabled = true
      } else {
        this.editDisabled = false
      }
      this.addForm.dfid = 0
      this.addForm.isfinish = 0
      this.addForm.imgids = []
      this.addForm.centent = ''
      this.addTitle = '添加跟进记录'
      this.imgLoad = new Date().getTime()
      this.addVisible = true
      this.editimgList = []
    },
    editRecord(ef) {
      this.editDisabled = true
      this.addForm.stage = ef.stage
      this.addForm.dfid = ef.dfid
      this.addForm.isfinish = ef.isfinish
      let oldimgids = []
      for (let img of ef.imgList) {
        oldimgids.push({ id: img.imgid, url: img.imgurl })
      }
      this.editimgList = oldimgids
      this.imgLoad = new Date().getTime()
      this.addForm.imgids = []
      this.addForm.centent = ef.centent
      this.addTitle = '编辑跟进记录'
      this.addVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addLoading) {
            this.addLoading = true
            const data = {
              isfinish: this.addForm.isfinish,
              stage: this.addForm.stage,
              userid: this.user.userid,
              did: this.info.did,
              centent: this.addForm.centent,
              imgids: this.addForm.imgids.join(','),
              dfid: this.addForm.dfid
            }
            addOrEditDecorationFollow(data).then(response => {
              this.$message({
                message: '项目跟进记录提交成功',
                type: 'success'
              })
              this.addLoading = false
              this.addVisible = false
              this.getData()
            }).catch(() => {
              this.addLoading = false
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.DecorationHomepage-container {
  .client-name{
    letter-spacing: 2px;
    color:#000;
  }
  .client-info-row{
    padding:6px 0;
  }
  .row-line{
    border-bottom: 1px solid #f5f7fa;
    padding-bottom: 14px;
    margin-bottom: 10px;
  }
  .client-sex{
    width: 16px!important;
    height: 16px!important;
    vertical-align: -4px!important;
  }
  .follow-txt{
    font-size: 13px;
  }
  .follow-content{
    color:#999;
    font-size: 13px;
  }
  .follow-editbtn{
    position: absolute;
    right:20px;
    top:40px;
  }
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .tags-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .tags-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
}
</style>
